<!-- 近三个到期客户 -->
<template>
  <div class="expiring">
    <!-- <h3>合约临期客户</h3> -->
    <el-table
      :data="dataList"
      border
      max-height="300px"
      ref="lazyTable"
      v-loading="loading"
      header-row-class-name="table-self-style"
    >
      <el-table-column label="序号" align="center" width="60">
        <template slot-scope="scope">
          <div>{{ scope.$index + 1 }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" width="100">
        <template slot-scope="{ row }">
          <el-button @click="goDetail(row)" type="text">查看详情</el-button>
        </template>
      </el-table-column> -->
      <el-table-column prop="corporate_name" label="公司名">
        <template slot-scope="{ row }">
          <div>
            {{ row.corporate_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="brand_name" label="品牌名">
        <template slot-scope="{ row }">
          <div @click="goDetail(row)" class="detail-btn">
            {{ row.brand_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="due_time" label="到期时间" width="120">
      </el-table-column>
      <el-table-column label="到期天数" width="120">
        <template slot-scope="{ row }">
          <div v-if="row.due_day <= 0" class="fontColor_danger">
            已到期 {{ Math.abs(row.due_day) }}天
          </div>
          <div v-else class="fontColor_warning">{{ row.due_day }}天后</div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 合同详情组件 -->
    <DetailContract :detailConfig="detailConfig"></DetailContract>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
import moment from "moment";

export default {
  data() {
    return {
      dataList: [],
      currentPage: 1,
      loadOver: false, // 加载完成 最后一页
      loading: false,
      // 合同详情查看
      detailConfig: {
        showSign: 0,
        contractProp: null,
      },
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    // this.lazyLoad();
  },
  methods: {
    goDetail(data) {
      this.detailConfig.showSign++;
      this.detailConfig.contractProp = {
        sign: 0, // 进入详情类型标识  // 合作中客户
        ...data,
      };
    },
    lazyLoadAdd() {
      this.$refs.lazyTable.bodyWrapper.addEventListener(
        "scroll",
        this.scrollHandler
      );
    },
    lazyLoadRemove() {
      this.$refs.lazyTable.bodyWrapper.removeEventListener(
        "scroll",
        this.scrollHandler
      );
    },
    scrollHandler() {
      let dom = this.$refs.lazyTable.bodyWrapper;
      const scrollDistance =
        dom.scrollHeight - dom.scrollTop - dom.clientHeight;
      if (scrollDistance <= 160 && !this.loadOver) {
        this.currentPage++;
        this.getData();
      }
    },
    getData() {
      let paramObj = {
        is_contract: 0,
        id: utils.sessionGetStore("user_id"),
        pageSize: 15,
        pageNow: this.currentPage,
        dueDayCount: 90, // 到期天数小于 90
        order: "2", //剩余天数由少到多
      };
      // 近三个月内
      // paramObj.due_time_start = moment().format("YYYY-MM-DD")
      // paramObj.due_time_end = moment().add(3,'M').format('YYYY-MM-DD')

      this.loading = true;
      this.$nextTick(() => {
        this.lazyLoadRemove();
      });

      api
        .getCustomersData(paramObj)
        .then((res) => {
          // console.log(res)
          let records = res.data.data.list;
          this.loadOver = records.length < 15;
          records.forEach((item) => {
            this.dataList.push({
              customer_id: item.customer_id,
              corporate_name: item.corporate_name,
              brand_name: item.brand_name,
              due_time: item.due_time.split(" ")[0],
              due_day: item.due_day,
            });
          });
          this.$nextTick(() => {
            this.lazyLoadAdd();
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.expiring {
  border-radius: 5px;
  height: 100%;
  background: #fff;
  padding-bottom: 10px;
  padding-left: 20px;
  > h3 {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 10px;
    font-size: 20px;
    padding-left: 20px;
    border-bottom: 1px solid #eee;
  }
  ::v-deep .table-self-style > th {
    background-color: #f8f8f8;
    padding: 5px 0;
  }
}
</style>
